import React, { Component } from 'react';
import VideoMuteWorkFinishRender from './children/VideoMuteWorkFinishRender';
import '@/assets/videoMute.less';
import Utils from '@/utils';
import { editorList } from '@/constants/url';
import sentGAEvent from '@/ga';
class VideoMuteFinishFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workPlaceVisible: false,
    };
  }

  addFileCallBack = (videoMuteObj) => {
    this.props.onVideoCompressObjChange(videoMuteObj);
  };

  handleDownload = () => {
    sentGAEvent({
      category: 'DownloadStart',
      action: '25VM_DownloadStart',
      label: 'Null',
    });
    Utils.downloadFile(this.props.videoMuteAfter, 'mp4');
  };

  handleGoToEdit = async () => {
    try {
      let blobUrl = await Utils.urlToBlob(
        this.props.videoMuteAfter.downloadurl
      );
      // let href = "https://www.hitpaw.com/online-tools-test/?type=videoCompress&work=cut&blob=" + blobUrl;
      // let href = `${Utils.getHitPawOnlineEditorLink()}?type=videoMute&work=cut&blob=${blobUrl}`;
      let href = `${editorList.get(
        'editor'
      )}?type=videoCompress&work=cut&blob=${blobUrl}`;

      window.open(href);
    } catch (error) {
      console.log(error);
    }
  };
  render() {
    return (
      <VideoMuteWorkFinishRender
        submitStatus={this.props.submitStatus}
        videoMuteAfter={this.props.videoMuteAfter}
        videoMuteObj={this.props.videoMuteObj}
        handleDownload={this.handleDownload}
        handleTryAgain={this.props.handleTryAgain}
        handleGoToEdit={this.handleGoToEdit}
      />
    );
  }
}

export default VideoMuteFinishFunction;
